import React , { useRef , useMemo } from 'react';
import moment from 'moment';
import { Line, Bar, Pie, Doughnut, Radar, PolarArea } from "react-chartjs-2";
import ReactApexChart from "react-apexcharts";
import getChartColorsArray from "../../../Components/Common/ChartsDynamicColor";
import "chart.js/auto";
import { CategoryScale, Chart } from "chart.js";
import ApexCharts from 'apexcharts';
Chart.register(CategoryScale);
// import { Chart, registerables } from 'chart.js';
// Chart.register(...registerables);


const LineChart = ({ data_set }) => {
    const data = {
        labels: data_set.xValues,
        datasets: data_set.yValues.map((item, index) => {
           return {
               label: item.label,
               data: item.data,
           } 
        })
        // datasets: [
        //     {
        //         label: "Sales Analytics",
        //         fill: true,
        //         lineTension: 0.5,
        //         backgroundColor: lineChartColor[0],
        //         borderColor: lineChartColor[1],
        //         borderCapStyle: 'butt',
        //         borderDash: [],
        //         borderDashOffset: 0.0,
        //         borderJoinStyle: 'miter',
        //         pointBorderColor: lineChartColor[1],
        //         pointBackgroundColor: "#fff",
        //         pointBorderWidth: 1,
        //         pointHoverRadius: 5,
        //         pointHoverBackgroundColor: lineChartColor[1],
        //         pointHoverBorderColor: "#fff",
        //         pointHoverBorderWidth: 2,
        //         pointRadius: 1,
        //         pointHitRadius: 10,
        //         data: [65, 59, 80, 81, 56, 55, 40, 55, 30, 80]
        //     },
        //     {
        //         label: "Monthly Earnings",
        //         fill: true,
        //         lineTension: 0.5,
        //         backgroundColor: lineChartColor[2],
        //         borderColor: lineChartColor[3],
        //         borderCapStyle: 'butt',
        //         borderDash: [],
        //         borderDashOffset: 0.0,
        //         borderJoinStyle: 'miter',
        //         pointBorderColor: lineChartColor[3],
        //         pointBackgroundColor: "#fff",
        //         pointBorderWidth: 1,
        //         pointHoverRadius: 5,
        //         pointHoverBackgroundColor: lineChartColor[3],
        //         pointHoverBorderColor: "#EEF0F2",
        //         pointHoverBorderWidth: 2,
        //         pointRadius: 1,
        //         pointHitRadius: 10,
        //         data: [80, 23, 56, 65, 23, 35, 85, 25, 92, 36]
        //     }
        // ]
    }
    const option = {
        x: {
            ticks: {
                font: {
                    family: 'Poppins',
                },
            },
        },
        y: {
            ticks: {
                font: {
                    family: 'Poppins',
                },
            },
        },
        plugins: {
            legend: {
                labels: {
                    // This more specific font property overrides the global property
                    font: {
                        family: 'Poppins',
                    }
                }
            },
        },
    }
    return (
        <React.Fragment>
            <Line width={723} height={320} data={data} options={option} />
        </React.Fragment>
    )
}
//Bar Chart
const BarChart = ({ data_set }) => {
    const data = {
        labels: data_set.labels,
        datasets:data_set.values.map((item, index) => {
            return{
                        label: item.label,
                        data: item.data,
                    
                }
        })
        // datasets: [
        //     {
        //         label: "Sales Analytics",
        //         backgroundColor: barChartColor[0],
        //         borderColor: barChartColor[0],
        //         borderWidth: 1,
        //         hoverBackgroundColor: barChartColor[1],
        //         hoverBorderColor: barChartColor[1],
        //         data: [65, 59, 81, 45, 56, 80, 50, 20]
        //     }
        // ]
    }
    const option = {
        x: {
            ticks: {
                font: {
                    family: 'Poppins',
                },
            },
        },
        y: {
            ticks: {
                font: {
                    family: 'Poppins',
                },
            },
        },
        plugins: {
            legend: {
                labels: {
                    font: {
                        family: 'Poppins',
                    }
                }
            },
        }
    }
    return (
        <React.Fragment>
            <Bar width={723} height={320} data={data} options={option} />
        </React.Fragment>
    )
}
//Pie Chart
const PieChart = ( {data_set} ) => {
    // var pieChartColors = getChartColorsArray(dataColors);
    
    const data = {
        labels: data_set?.data?.map((item) => item.label),
        datasets: [
            {
                data: data_set?.data?.map((item) => item.value),
                // backgroundColor: pieChartColors,
                // hoverBackgroundColor: pieChartColors,
                // hoverBorderColor: "#fff"
            }]
    },
        option = {
            plugins: {
                legend: {
                    labels: {
                        font: {
                            family: 'Poppins',
                        }
                    }
                },
            }
        }
    return (
        <React.Fragment>
            <Pie data={data} options={option} className="chartjs-chart" />
        </React.Fragment>
    )
}
//Donut Chart
const DonutChart = ({ dataColors }) => {
    var doughnutChartColors = getChartColorsArray(dataColors);
    const data = {
        labels: [
            "Desktops",
            "Tablets"
        ],
        datasets: [
            {
                data: [300, 210],
                backgroundColor: doughnutChartColors,
                hoverBackgroundColor: doughnutChartColors,
                hoverBorderColor: "#fff"
            }]
    },
        option = {
            plugins: {
                legend: {
                    labels: {
                        font: {
                            family: 'Poppins',
                        }
                    }
                },
            }
        }
    return (
        <React.Fragment>
            <Doughnut data={data} options={option} className="chartjs-chart" />
        </React.Fragment>
    )
}
//Polar Chart
const PolarChart = ({ dataColors }) => {
    var polarAreaChartColors = getChartColorsArray(dataColors);
    const data = {
        labels: [
            "Series 1",
            "Series 2",
            "Series 3",
            "Series 4"
        ],
        datasets: [{
            data: [
                11,
                16,
                7,
                18
            ],
            backgroundColor: polarAreaChartColors,
            label: 'My dataset', // for legend
            hoverBorderColor: "#fff"
        }]
    }
    const option = {
        plugins: {
            legend: {
                labels: {
                    font: {
                        family: 'Poppins',
                    }
                }
            },
        }
    }
    return (
        <React.Fragment>
            <PolarArea className="chartjs-chart" data={data} options={option} />
        </React.Fragment>
    )
}
//Radar Chart
const RadarChart = ({ dataColors }) => {
    var radarChartColors = getChartColorsArray(dataColors);
    const data = {
        labels: ["Eating", "Drinking", "Sleeping", "Designing", "Coding", "Cycling", "Running"],
        datasets: [
            {
                label: "Desktops",
                backgroundColor: radarChartColors[0],
                borderColor: radarChartColors[1], //"#2AB57D",
                pointBackgroundColor: radarChartColors[1], //"#2AB57D",
                pointBorderColor: "#fff",
                pointHoverBackgroundColor: "#fff",
                pointHoverBorderColor: radarChartColors[1], //"#2AB57D",
                data: [65, 59, 90, 81, 56, 55, 40]
            },
            {
                label: "Tablets",
                backgroundColor: radarChartColors[2], //"rgba(81, 86, 190, 0.2)",
                borderColor: radarChartColors[3], //"#5156BE",
                pointBackgroundColor: radarChartColors[3], //"#5156BE",
                pointBorderColor: "#fff",
                pointHoverBackgroundColor: "#fff",
                pointHoverBorderColor: radarChartColors[3], //"#5156BE",
                data: [28, 48, 40, 19, 96, 27, 100]
            }
        ]
    },
        option = {
            plugins: {
                legend: {
                    labels: {
                        font: {
                            family: 'Poppins',
                        }
                    }
                },
            }
        }
    return (
        <React.Fragment>
            <Radar className="chartjs-chart" data={data} options={option} />
        </React.Fragment>
    )
}

//stacked Chart
const StackedBarChart = ({ dataColors , data_set }) => {
    // var chartStackedBarColors = getChartColorsArray(dataColors);
    const series = data_set?.series?JSON.parse(JSON.stringify(data_set?.series)):[];
    var options = {
        chart: {
            type: 'bar',
            height: 350,
            stacked: true,
            toolbar: {
                show: false,
            }
        },
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 10,
            borderRadiusApplication: 'end', // 'around', 'end'
            borderRadiusWhenStacked: 'last', // 'all', 'last'
            dataLabels: {
              total: {
                enabled: true,
                style: {
                  fontSize: '13px',
                  fontWeight: 900
                }
              }
            }
          },
        },
        stroke: {
            width: 1,
            colors: ['#fff']
        },
        title: {
            text: 'Fiction Books Sales',
            style: {
                fontWeight: 500,
            },
        },
        xaxis: {
            categories: [2008, 2009, 2010, 2011, 2012, 2013, 2014],
            labels: {
                formatter: function (val) {
                    return val + "K";
                }
            }
        },
        yaxis: {
            title: {
                text: undefined
            },
        },
        tooltip: {
            y: {
                formatter: function (val) {
                    return val + "K";
                }
            }
        },
        fill: {
            opacity: 1
        },
        legend: {
            position: 'top',
            horizontalAlign: 'left',
            offsetX: 40
        },
        // colors: chartStackedBarColors,
    };

    return (
        <React.Fragment>
            <ReactApexChart dir="ltr"
                className="apex-charts"
                options={JSON.parse(JSON.stringify(data_set))}
                series={series}
                type="bar"
                height={350}
            />
        </React.Fragment>
    );
};

// Bar Char With Mark
const BarCharWithMarkers = ({ dataColors , data_set }) => {
    // var chartBarMarkersColors = getChartColorsArray(dataColors);
    const series = data_set?.series?JSON.parse(JSON.stringify(data_set?.series)):[];

    var options = {
        chart: {
            toolbar: {
                show: !1,
            },
        },
        plotOptions: {
            bar: {
                horizontal:false,
            },
        },
        // colors: chartBarMarkersColors,
        dataLabels: {
            formatter: function (val, opt) {
                var goals =
                    opt.w.config.series[opt.seriesIndex].data[opt.dataPointIndex].goals;

                if (goals && goals.length) {
                    return `${val} / ${goals[0].value}`
                }
                return val;
            },
        },
        legend: {
            show: !0,
            showForSingleSeries: !0,
            customLegendItems: ["Actual", "Expected"],
            Markers: {
                fillColors: ["#00E396", "#775DD0"],
            },
        },
    };

    return (
        <React.Fragment>
            <ReactApexChart dir="ltr"
                className="apex-charts"
                options={JSON.parse(JSON.stringify(data_set))}
                series={series}
                type="bar"
                height={350}
            />
        </React.Fragment>
    );
};

// multilinechart
// const MultiLineChart = ({ dataColors }) => {
//     var series = [{
//         name: "Session Duration",
//         data: [0, 52, 38, 24, 33, 26, 21, 20, 6, 8, 15, 10]
//     },
//     {
//         name: "Page Views",
//         data: [0, 42, 60, 42, 13, 18, 29, 37, 36, 51, 32, 35]
//     },
//     ];
//     var options = {
//         chart: {
//             height: 380,
//             type: 'line',
//             zoom: {
//                 enabled: false
//             },
//             toolbar: {
//                 show: false,
//             }
//         },
        
//         dataLabels: {
//             enabled: false
//         },
//         stroke: {
//             width: [4, 4],
//             curve: 'straight',
//             dashArray: [0, 0]
//         },
//         title: {
//             text: 'Page Statistics',
//             align: 'left',
//             style: {
//                 fontWeight: 500,
//             },
//         },
//         markers: {
//             size: 0,

//             hover: {
//                 sizeOffset: 6
//             }
//         },
//         xaxis: {
//             categories: ['01 Jan', '02 Jan', '03 Jan', '04 Jan', '05 Jan', '06 Jan', '07 Jan', '08 Jan', '09 Jan',
//                 '10 Jan', '11 Jan', '12 Jan'
//             ],
//         },
//         tooltip: {
//             y: [{
//                 title: {
//                     formatter: function (val) {
//                         return val + " (mins)";
//                     }
//                 }
//             }, {
//                 title: {
//                     formatter: function (val) {
//                         return val + " per session";
//                     }
//                 }
//             }]
//         },
//         grid: {
//             borderColor: '#f1f1f1',
//         }
//     };
//     return (
//         <React.Fragment>
//             <ReactApexChart dir="ltr"
//                 options={options}
//                 series={series}
//                 type="line"
//                 height="380"
//                 className="apex-charts"
//             />
//         </React.Fragment>
//     );
// };

//multiaxisline chart

const MultiAxisLineChart = ({ data_set }) => {
    data_set = JSON.parse(JSON.stringify(data_set))
    
  const series = data_set.series;

//   const options = {
//     chart: {
//     //   height: height,
//       type: 'line',
//       toolbar: {
//         show: true,
//       }
//     },
//     stroke: {
//       width: [3, 3],
//       curve: 'smooth'
//     },
//     colors: ['#FF1654', '#247BA0'],
//     dataLabels: {
//       enabled: false
//     },
//     markers: {
//       size: 5
//     },
//     xaxis: {
//       categories: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
//     },
//     yaxis: [
//       {
//         title: {
//           text: "Temperature (°C)",
//         },
//         labels: {
//           style: {
//             color: '#FF1654'
//           }
//         }
//       },
//       {
//         opposite: true,
//         title: {
//           text: "Rainfall (mm)",
//         },
//         labels: {
//           style: {
//             color: '#247BA0'
//           }
//         }
//       }
//     ],
//     tooltip: {
//       shared: true,
//       intersect: false,
//     },
//     legend: {
//       position: 'top',
//       horizontalAlign: 'left',
//       offsetX: 10
//     }
//   };

  return (
    <ReactApexChart
      options={data_set}
      series={series}
      type="line"
    //   height={height}
    //   width={width}
    />
  );
};

const AreaCharts = ({ data_set }) => {
  const rawSeries = data_set?.series || [];
  const labels = data_set?.labels || [];

  // Unique chart id so ApexCharts.exec targets the right chart
  const chartIdRef = useRef(`area-${Math.random().toString(36).slice(2)}`);

  // ---- Detect date-axis & build [timestamp, value] data if needed ----
  const { isDateAxis, parsedTimestamps, seriesForChart } = useMemo(() => {
    // try parse all labels as dates
    const parsed = labels.map((l) => {
      const t = Date.parse(l);
      return Number.isFinite(t) ? t : NaN;
    });
    const validCount = parsed.filter((t) => Number.isFinite(t)).length;
    const isDateAxis = labels.length > 0 && validCount / labels.length >= 0.7;

    if (!isDateAxis) {
      return { isDateAxis: false, parsedTimestamps: [], seriesForChart: rawSeries };
    }

    // Convert each series point to [ts, y] aligned by label index
    const seriesForChart = rawSeries.map((s) => {
      const data = (s.data || []).map((y, i) => {
        const ts = parsed[i];
        return Number.isFinite(ts) ? [ts, y] : null;
      }).filter(Boolean);
      return { ...s, data };
    });

    const parsedTimestamps = parsed.filter((t) => Number.isFinite(t));
    return { isDateAxis, parsedTimestamps, seriesForChart };
  }, [labels, rawSeries]);

  // ---- Compute domain from actual data points (more reliable than labels) ----
  const domain = useMemo(() => {
    if (!isDateAxis) return null;
    let min = Infinity, max = -Infinity;
    for (const s of seriesForChart) {
      for (const p of s.data || []) {
        const ts = Array.isArray(p) ? p[0] : null;
        if (Number.isFinite(ts)) {
          if (ts < min) min = ts;
          if (ts > max) max = ts;
        }
      }
    }
    if (!Number.isFinite(min) || !Number.isFinite(max)) return null;
    return { min, max };
  }, [isDateAxis, seriesForChart]);

  // ---- Range helpers (use updateOptions for stable zooming) ----
  const setRange = (minTs, maxTs) => {
    if (!domain) return;
    const min = Math.max(minTs, domain.min);
    const max = Math.min(maxTs, domain.max);
    ApexCharts.exec(chartIdRef.current, "updateOptions", { xaxis: { min, max } }, false, false);
  };

  const zoomAll = () => {
    if (!domain) return;
    ApexCharts.exec(chartIdRef.current, "updateOptions", {
      xaxis: { min: domain.min, max: domain.max }
    }, false, false);
  };

  const zoomLastMonths = (months) => {
    if (!domain) return;
    // True "calendar months"
    const end = new Date(domain.max);
    const start = new Date(end);
    start.setMonth(start.getMonth() - months);
    setRange(start.getTime(), end.getTime());
  };

  const zoomYTD = () => {
    if (!domain) return;
    const end = new Date(domain.max);
    const start = new Date(end.getFullYear(), 0, 1); // Jan 1
    start.setHours(0, 0, 0, 0);
    setRange(start.getTime(), end.getTime());
  };

  const zoomLastYears = (years) => {
    if (!domain) return;
    const end = new Date(domain.max);
    const start = new Date(end);
    start.setFullYear(start.getFullYear() - years);
    setRange(start.getTime(), end.getTime());
  };

  // ---- Apex options ----
  const options = {
    chart: {
      id: chartIdRef.current,
      type: "area",
      height: 350,
      zoom: {
        type: "x",
        enabled: true,
        autoScaleYaxis: true
      },
      toolbar: {
        show: true,
        tools: {
          download: true,
          selection: true,
          zoom: true,
          zoomin: true,
          zoomout: true,
          pan: true,
          reset: true
        },
        autoSelected: "zoom"
      }
    },
    dataLabels: { enabled: false },
    stroke: { curve: "straight" },
    xaxis: isDateAxis
      ? { type: "datetime", labels: { datetimeUTC: false } }
      : { type: "category", categories: labels }
  };

  return (
    <React.Fragment>
      {isDateAxis && (
        <div className="btn-sec-style" style={{ display: "flex", gap: 8, marginBottom: 8, flexWrap: "wrap" }}>
          <button className='btn btn-secondary' onClick={() => zoomLastMonths(1)}>1M</button>
          <button className='btn btn-secondary' onClick={() => zoomLastMonths(3)}>3M</button>
          <button className='btn btn-secondary' onClick={() => zoomLastMonths(6)}>6M</button>
          <button className='btn btn-secondary' onClick={zoomYTD}>YTD</button>
          <button className='btn btn-secondary' onClick={() => zoomLastYears(1)}>1Y</button>
          <button className='btn btn-secondary' onClick={zoomAll}>ALL</button>
        </div>
      )}

      <ReactApexChart
        dir="ltr"
        options={options}
        series={isDateAxis ? seriesForChart : rawSeries}
        type="area"
        height={350}
        className="apex-charts"
      />
    </React.Fragment>
  );
};

const RangeBarChart = ({ data_set }) => {

    

    const series = data_set.series
    data_set = restoreFunctions(data_set)
   

    return (
        <React.Fragment>
            <ReactApexChart dir="ltr"
                className="apex-charts"
                options={data_set}
                series={series}
                type="rangeBar"
                height={350}
            />
        </React.Fragment>
    );
};

// heat map 
function generateData(count, yrange) {
  const series = [];
  for (let i = 0; i < count; i++) {
    const x = (i + 1).toString();
    const y = Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;
    series.push({ x, y });
  }
  return series;
}

const Heatmap = ({ dataColors }) => {
  const series = [
    { name: 'Metric1', data: generateData(18, { min: 0, max: 90 }) },
    { name: 'Metric2', data: generateData(18, { min: 0, max: 90 }) },
    { name: 'Metric3', data: generateData(18, { min: 0, max: 90 }) },
    { name: 'Metric4', data: generateData(18, { min: 0, max: 90 }) },
    { name: 'Metric5', data: generateData(18, { min: 0, max: 90 }) },
    { name: 'Metric6', data: generateData(18, { min: 0, max: 90 }) },
    { name: 'Metric7', data: generateData(18, { min: 0, max: 90 }) },
    { name: 'Metric8', data: generateData(18, { min: 0, max: 90 }) },
    { name: 'Metric9', data: generateData(18, { min: 0, max: 90 }) },
  ];

  const options = {
    chart: {
      height: 450,
      type: 'heatmap',
      toolbar: { show: false }
    },
    dataLabels: { enabled: false },
    title: {
      text: 'HeatMap Chart (Single color)',
      style: { fontWeight: 500 }
    },
    colors: [dataColors || "#008FFB"], // Default to blue if not provided
  };

  return (
    <ReactApexChart
      dir="ltr"
      className="apex-charts"
      series={series}
      options={options}
      type="heatmap"
      height={450}
    />
  );
};



const SimpleDonutChart = ({ data_set }) => {
  const series = data_set.data[0].series;

  const options = data_set.data[0];


  console.log("Donut chart data",data_set )

  return (
    <ReactApexChart
      dir="ltr"
      className="apex-charts"
      series={series}
      options={options}
      type="donut"
      height={350}
    />
  );
};

const LineBarChart = ({ dataColors, data_set }) => {
   
  const series = data_set.series;

  const options = data_set;

  return (
    <ReactApexChart
      dir="ltr"
      className="apex-charts"
      series={series}
      options={options}
      type="line"
      height={400}
    />
  );
};

const generateScatterData = (count, yrange) => {
  const series = [];
  for (let i = 0; i < count; i++) {
    const x = Math.floor(Math.random() * (750 - 1 + 1)) + 1;
    const y =
      Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;
    series.push([x, y]);
  }
  return series;
};

const ScatterChart = ({ dataColors }) => {
  const series = [
    { name: "Sample A", data: generateScatterData(20, { min: 10, max: 60 }) },
    { name: "Sample B", data: generateScatterData(20, { min: 10, max: 60 }) },
    { name: "Sample C", data: generateScatterData(20, { min: 10, max: 60 }) },
  ];

  const options = {
    chart: {
      type: "scatter",
      zoom: { enabled: true, type: "xy" },
      toolbar: { show: false },
    },
    xaxis: { tickAmount: 10, title: { text: "X Axis" } },
    yaxis: { title: { text: "Y Axis" } },
    legend: { position: "top" },
    tooltip: { shared: false, intersect: true },
    colors: dataColors || ["#008FFB", "#00E396", "#FEB019"],
  };

  return (
    <ReactApexChart
      dir="ltr"
      className="apex-charts"
      series={series}
      options={options}
      type="scatter"
      height={400}
    />
  );
};

const HorizontalBarChart = ({ dataColors, data_set }) => {
  const series = [
    {
      name: "Sales",
      data: data_set?.series || [],
    },
  ];

  const options = {
    chart: {
      type: "bar",
      height: 350,
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        borderRadius: 4,
        borderRadiusApplication: "end",
      },
    },
    dataLabels: { enabled: false },
    xaxis: {
      categories: data_set?.categories || [],
    },
    colors: dataColors || ["#008FFB"],
    legend: { position: "top" },
    tooltip: { shared: true },
  };

  return (
    <ReactApexChart
      className="apex-charts"
      series={series}
      options={options}
      type="bar"
      height={400}
    />
  );
};


export { HorizontalBarChart, ScatterChart, LineBarChart, SimpleDonutChart, LineChart, BarChart, PieChart, DonutChart, PolarChart, RadarChart, StackedBarChart, BarCharWithMarkers, MultiAxisLineChart, AreaCharts, RangeBarChart, Heatmap }

function restoreFunctions(config) {
  // Safely convert a stringified function to a real JS function
  function safelyParseFunction(funcStr) {
    try {
      if (typeof funcStr === 'string' && funcStr.trim().startsWith("function(")) {
        const argsStart = funcStr.indexOf('(') + 1;
        const argsEnd = funcStr.indexOf(')');
        const args = funcStr.slice(argsStart, argsEnd).trim();
        const body = funcStr.slice(funcStr.indexOf('{') + 1, funcStr.lastIndexOf('}')).trim();
        return new Function(args, body);
      }
    } catch (e) {
      console.warn("Failed to parse formatter function:", e);
    }
    return null;
  }

  // Handle dataLabels.formatter if it's a string
  if (config.dataLabels && typeof config.dataLabels.formatter === "string") {
    const parsedFn = safelyParseFunction(config.dataLabels.formatter);
    if (parsedFn) {
      config.dataLabels.formatter = parsedFn;
    }
  }

  return config;
}